import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=9d366424&"
import script from "./BannerForm.vue?vue&type=script&lang=js&"
export * from "./BannerForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=9d366424&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports